import {Theme, ThemeProvider} from '@mui/material'
import React from 'react'

import {hpFundamentalContrastTheme, hpFundamentalLightTheme} from './themeConfig'

/**
 * Resets the on-blue contrast theme back to the light theme, leaving any other
 * ambient theme untouched. The contrast theme is detected by its unique blue
 * paper colour so the check stays robust across duplicate module instances
 * (reference equality is not reliable across bundle boundaries).
 */
export const resolveOverlaySurfaceTheme = (outerTheme: Theme): Theme =>
  outerTheme.palette.background.paper === hpFundamentalContrastTheme.palette.background.paper
    ? hpFundamentalLightTheme
    : outerTheme

/**
 * Wrap floating overlay surfaces (menus, popovers, date-picker calendars) so
 * they render as their own card rather than inheriting the on-blue contrast
 * palette. On the legacy blue surface a `FilterContrastProvider` swaps in the
 * contrast theme, whose `text.primary` is white and would be invisible on a
 * light card; this resets descendants to the light theme. Suite keeps its
 * ambient theme (light/dark), so the overlay follows the active mode there.
 */
export const OverlaySurfaceThemeProvider: React.FC<{children: React.ReactNode}> = ({children}) => (
  <ThemeProvider theme={resolveOverlaySurfaceTheme}>{children}</ThemeProvider>
)
